import React, { useState, useEffect } from "react";
import "./assets/css/style.scss";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { Navigate } from "react-router-dom";
import Login from "./auth/Login";
import ForgotPassword from "./auth/ForgotPassword";
import ResetPassword from "./auth/ResetPassword";
import OTP from "./auth/OTP";
import Layout from "./Layout";
import Dashboard from "./screens/Dashboard";
import Users from "./screens/Users";
import Adduser from "./screens/Users/Adduser";
import Edituser from "./screens/Users/Edituser";
import Viewuser from "./screens/Users/Viewuser";
import ProfileSettings from "./screens/ProfileSettings";
import Tales from "./screens/Tales";
import Viewtale from "./screens/Tales/Viewtale";
import AIGeneratedTales from "./screens/AIGeneratedTales";
import ViewAIGeneratedtale from "./screens/AIGeneratedTales/ViewAIGeneratedtale";
import ViewAIGeneratedStories from "./screens/AIGeneratedStories/ViewAIGeneratedStories/index";

import Characters from "./screens/Characters";
import ViewCharacter from "./screens/Characters/ViewCharacter";
import Reports from "./screens/Reports";
import Viewreport from "./screens/Reports/Viewreport";
import AnalyticsInsights from "./screens/AnalyticsInsights";
import Notifications from "./screens/Notifications";
import FeedbackSupport from "./screens/FeedbackSupport";
import Viewfeedback from "./screens/FeedbackSupport/Viewfeedback";
import Viewsupport from "./screens/FeedbackSupport/Viewsupport";
import SubscriptionPackages from "./screens/SubscriptionPackages";
import Subscribers from "./screens/Subscribers";
import RevenueReports from "./screens/RevenueReports";
import ViewRevenue from "./screens/RevenueReports/ViewRevenue";
import ProtectedRoute from "./middlewares/ProtectedRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Sentry } from "react-activity";
import "react-activity/dist/library.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Books from "./screens/Books";
import Viewbook from "./screens/Books/Viewbook";
import Chapterdetails from "./screens/Books/Chapterdetails";
import AllPages from "./screens/AllPages";
import { useAuthStore } from "./store/useAuthStore";

function App() {
  const [loading, setLoading] = useState(false);
  const initialize = useAuthStore((state) => state.initialize);
  
  useEffect(() => {
    // Initialize auth state
    initialize();
    
    // Set loading state
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    
    return () => clearTimeout(timer);
  }, [initialize]);
  
  function ScrollToTop() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
      if (hash) {
        const section = document.getElementById(hash.replace("#", ""));
        if (section) {
          setTimeout(() => {
            section.scrollIntoView({ behavior: "smooth" });
          }, 100); // Delay for page render
        }
      } else {
        window.scrollTo(0, 0);
      }
    }, [pathname, hash]);
    return null;
  }
  return (
    <>
      <ToastContainer />
      {loading ? (
        <div className="loaderdiv">
          <Sentry color="#800020" size={40} speed={1} animating={true} />
        </div>
      ) : (
        // <Router basename={process.env.REACT_APP_BASENAME}>
        <Router>
          <ScrollToTop />
          <Routes>
            {/* <Route exact path="/" element={<Login />} /> */}
            <Route
              exact
              path="/"
              element={
                localStorage.getItem("authToken") ? (
                  <Navigate to="/dashboard" replace />
                ) : (
                  <Login />
                )
              }
            />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/otp" element={<OTP />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            {/* <Route path="/dashboard" element={<Layout title={"Dashboard"}><Dashboard /></Layout>} /> */}

            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Layout title={"Dashboard"}>
                    <Dashboard />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute>
                  <Layout title={"Users"}>
                    <Users />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/books"
              element={
                <ProtectedRoute>
                  <Layout title={"Books"}>
                    <Books />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/books/view-book/:bookId"
              element={
                <ProtectedRoute>
                  <Layout title={"Book Details"}>
                    <Viewbook />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/books/chapter-details/:chapterId"
              element={
                <ProtectedRoute>
                  <Layout title={"Chapter Details"}>
                    <Chapterdetails />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-user"
              element={
                <ProtectedRoute>
                  <Layout title={"Add User"}>
                    <Adduser />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/update-profile/:userId"
              element={
                <ProtectedRoute>
                  <Layout title={"Edit User"}>
                    <Edituser />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/view-user/:userId"
              element={
                <ProtectedRoute>
                  <Layout title={"User Details"}>
                    <Viewuser />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/tales"
              element={
                <ProtectedRoute>
                  <Layout title={"Tales"}>
                    <Tales />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/tale-detail/:taleId"
              element={
                <ProtectedRoute>
                  <Layout title={"Tale Details"}>
                    <Viewtale />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/ai-generated-tales"
              element={
                <ProtectedRoute>
                  <Layout title={"AI-Generated Tales"}>
                    <AIGeneratedTales />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/tale-detail/:taleId"
              element={
                <ProtectedRoute>
                  <Layout title={"AI-Generated Tale Details"}>
                    <ViewAIGeneratedtale />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/view-story/:storyId"
              element={
                <ProtectedRoute>
                  <Layout title={"AI-Generated Tale Details"}>
                    <ViewAIGeneratedStories />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/characters"
              element={
                <ProtectedRoute>
                  <Layout title={"Characters"}>
                    <Characters />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/character-detail/:characterId"
              element={
                <ProtectedRoute>
                  <Layout title={"Character Details"}>
                    <ViewCharacter />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <ProtectedRoute>
                  <Layout title={"Reports"}>
                    <Reports type="tales"/>
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/user-reports"
              element={
                <ProtectedRoute>
                  <Layout title={"Reports"}>
                    <Reports type="user" />
                  </Layout>
                </ProtectedRoute>
              }
            />


            <Route
              path="/admin/report-detail/:reportId"
              element={
                <ProtectedRoute>
                  <Layout title={"Report Details"}>
                    <Viewreport />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/analytics-insights"
              element={
                <ProtectedRoute>
                  <Layout title={"Analytics & Insights"}>
                    <AnalyticsInsights />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/notifications"
              element={
                <ProtectedRoute>
                  <Layout title={"Notifications"}>
                    <Notifications />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/feedback-support"
              element={
                <ProtectedRoute>
                  <Layout title={"Feedback & Support"}>
                    <FeedbackSupport />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/feedback-detail/:feedbackId"
              element={
                <ProtectedRoute>
                  <Layout title={"Feedback Details"}>
                    <Viewfeedback />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/support-detail/:supportId"
              element={
                <ProtectedRoute>
                  <Layout title={"Support Details"}>
                    <Viewsupport />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/subscription-packages"
              element={
                <ProtectedRoute>
                  <Layout title={"Subscription Packages"}>
                    <SubscriptionPackages />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/subscribers"
              element={
                <ProtectedRoute>
                  <Layout title={"Subscribers"}>
                    <Subscribers />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/revenue-reports"
              element={
                <ProtectedRoute>
                  <Layout title={"Revenue Reports"}>
                    <RevenueReports />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/report-detail"
              element={
                <ProtectedRoute>
                  <Layout title={"Revenue Report Details"}>
                    <ViewRevenue />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/allpages"
              element={
                <ProtectedRoute>
                  <Layout title={"All Pages"}>
                    <AllPages />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile-settings"
              element={
                <ProtectedRoute>
                  <Layout title={"Profile Settings"}>
                    <ProfileSettings />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route 
              path="*" 
              element={
                localStorage.getItem("authToken") ? (
                  <Navigate to="/dashboard" replace />
                ) : (
                  <Navigate to="/" replace />
                )
              } 
            />
          </Routes>
        </Router>
      )}
    </>
  );
}

export default App;
